import * as React from "react";
import { Send16Regular, ThumbDislikeRegular, ThumbLikeRegular } from "@fluentui/react-icons";
import { IAiChatMessage, IAiFeedbackStateItem } from "./AiSearchTypes";


interface IAiFeedbackProps {
    message: IAiChatMessage;
    feedback: IAiFeedbackStateItem;
    onPositive: (messageId: string, serverMessageId?: string) => void;
    onNegative: (messageId: string, serverMessageId?: string) => void;
    onCommentChange: (messageId: string, value: string) => void;
    onSubmitNegative: (messageId: string, serverMessageId?: string) => void;
}

const AiFeedback = ({
    message,
    feedback,
    onPositive,
    onNegative,
    onCommentChange,
    onSubmitNegative
}: IAiFeedbackProps) => {
    if (message.role !== "assistant" || (!message.text && !message.tables)) {
        return null;
    }

    const feedbackValue = feedback.feedback;
    const submitted = !!feedback.submitted;
    const showThankYou = submitted || feedbackValue === "up";
    const hasComment = !!String(feedback.comment || "").trim();

    return (
        <div className="aiFeedbackWrap">
            <div className="aiFeedbackHeader">
                <span className="aiFeedbackLabel">Is this useful?</span>
                <button
                    title="Yes"
                    aria-label="Thumbs up"
                    className={`aiFeedbackThumb ${!submitted && feedbackValue === "up" ? "active-up" : ""} ${submitted ? "is-disabled" : ""}`}
                    onClick={() => onPositive(message.id, message.serverMessageId)}
                    disabled={submitted}
                >
                    <ThumbLikeRegular />
                </button>
                <button
                    title="No"
                    aria-label="Thumbs down"
                    className={`aiFeedbackThumb ${!submitted && feedbackValue === "down" ? "active-down" : ""} ${submitted ? "is-disabled" : ""}`}
                    onClick={() => onNegative(message.id, message.serverMessageId)}
                    disabled={submitted}
                >
                    <ThumbDislikeRegular />
                </button>
            </div>
            {feedbackValue === "down" && !submitted && (
                <div className="aiFeedbackBox">
                    <textarea
                        className="aiFeedbackTextarea"
                        placeholder="Please tell us what was not useful..."
                        value={feedback.comment || ""}
                        onChange={e => onCommentChange(message.id, e.target.value)}
                        maxLength={1000}
                        rows={2}
                    />
                    <button
                        type="button"
                        title="Submit feedback"
                        onClick={() => onSubmitNegative(message.id, message.serverMessageId)}
                        className="aiFeedbackSubmitBtn"
                        aria-label="Submit feedback"
                        role="button"
                        disabled={!hasComment}
                    >
                        <Send16Regular aria-hidden="true" />
                    </button>
                </div>
            )}
            {showThankYou && (
                <div className="aiFeedbackThanks">Thank you for your feedback!</div>
            )}
        </div>
    );
};

export default AiFeedback;
